import React from "react";

interface Variant {
  variantId: string;
  variantName: string;
  price: number;
  stock: number;
}

interface Item {
  itemId: string;
  name: string;
  description?: string;
  images?: any;
  variants: Variant[];
}

interface ItemCardProps {
  item: Item;
  onEdit?: (item: Item) => void;
}

const ItemCard: React.FC<ItemCardProps> = ({ item, onEdit }) => {
  return (
    <div className="border rounded-xl shadow-md p-4 bg-white">
      {item.images[0]?.url ? (
        <img
          src={item.images[0]?.url}
          alt={item.name}
          className="w-full h-40 object-cover rounded-lg mb-3"
        />
      ) : (
        <div className="w-full h-40 bg-gray-100 rounded-lg flex items-center justify-center mb-3 text-gray-400">
          No Image
        </div>
      )}

      <h2 className="text-lg font-semibold mb-1">{item.name}</h2>
      <p className="text-gray-500 text-sm mb-2">{item.description}</p>

      <div className="space-y-2">
        {item.variants.map((variant) => (
          <div
            key={variant.variantId}
            className="flex justify-between text-sm text-gray-700 border-t pt-2"
          >
            <span className="font-medium">{variant.variantName}</span>
            <span>
              ₹{variant.price} | Stock: {variant.stock}
            </span>
          </div>
        ))}
      </div>
      <button
        onClick={() => onEdit?.(item)}
        className="mt-4 bg-blue-600 text-white text-sm px-3 py-1.5 rounded hover:bg-blue-700 transition"
      >
        Edit
      </button>
    </div>
  );
};

export default ItemCard;
